export interface FaqItem {
  question: string;
  answer: string;
  category: string;
}

export const faqData: FaqItem[] = [
  {
    category: 'Getting Started',
    question: 'What is For Visibility?',
    answer:
      'For Visibility is an AI-native operating system for resellers. It connects your selling platforms — eBay, Mercari, Poshmark, and more — into a single dashboard where AI handles listing optimization, inventory management, pricing intelligence, and transaction tracking so you can scale your reselling business without hiring a team.',
  },
  {
    category: 'Getting Started',
    question: 'How do I create an account?',
    answer:
      'Click the "Start free" button on our landing page, enter your email and create a password. You can connect your first marketplace immediately and start listing within minutes. No credit card required for the Free tier.',
  },
  {
    category: 'Getting Started',
    question: 'Which marketplaces do you support?',
    answer:
      'We currently support eBay, Mercari, and Poshmark with direct integrations. More platforms are in development. Each marketplace connects securely via its official API — we never ask for your login credentials.',
  },
  {
    category: 'Billing & Plans',
    question: 'How does pricing work?',
    answer:
      'For Visibility is subscription-based with four tiers: Free, Pro ($19/mo), Power ($49/mo), and Studio ($129/mo). We never take a percentage of your sales. All paid plans include a full data export if you choose to cancel. See our pricing page for a complete feature comparison.',
  },
  {
    category: 'Billing & Plans',
    question: 'Can I change or cancel my plan?',
    answer:
      'Yes. You can upgrade, downgrade, or cancel at any time. If you cancel, your data remains available for export in CSV and JSON formats for 30 days. There are no early-termination fees or hidden penalties. Your data is yours.',
  },
  {
    category: 'Billing & Plans',
    question: 'Do you offer refunds?',
    answer:
      "We offer a 14-day money-back guarantee on all paid plans. If For Visibility isn't the right fit, contact our support team within 14 days of your first payment for a full refund. After 14 days, refunds are handled on a case-by-case basis.",
  },
  {
    category: 'Data & Privacy',
    question: 'How do you protect my data?',
    answer:
      'All data is encrypted at rest (AES-256) and in transit (TLS 1.3). We use industry-standard security practices including regular third-party audits, strict access controls, and no sharing of your data with third parties. See our Security and Privacy pages for full details.',
  },
  {
    category: 'Data & Privacy',
    question: 'Can I export my data?',
    answer:
      'Absolutely. Every plan includes full data export in CSV and JSON formats. You can export your listings, transactions, inventory, and analytics at any time from your Settings page. We believe your data belongs to you, not us.',
  },
  {
    category: 'Data & Privacy',
    question: 'Do you sell my data?',
    answer:
      'Never. We do not sell, rent, or share your personal information with third parties for their marketing purposes. Your marketplace data, financial information, and personal details stay strictly within For Visibility. This is a core promise — see our Privacy Policy for the full legal details.',
  },
  {
    category: 'AI & Features',
    question: 'How does the AI work?',
    answer:
      'Our AI analyzes your inventory, market trends, and sales history to optimize listings, suggest pricing, and automate repetitive tasks. Different tiers unlock different AI capabilities — from automated listing optimization to full autonomous mode that can manage your shop end-to-end.',
  },
  {
    category: 'AI & Features',
    question: 'Can the AI post listings automatically?',
    answer:
      'Yes, on the Power and Studio plans, autonomous mode can draft, optimize, and publish listings across your connected platforms. You set the guardrails — minimum price, listing templates, approval requirements — and the AI operates within those bounds. You retain full control.',
  },
  {
    category: 'AI & Features',
    question: 'What is Co-Pilot mode?',
    answer:
      'Co-Pilot mode (available on Pro and above) provides real-time AI suggestions as you work. It can recommend pricing, flag listing improvements, identify trending categories, and alert you to marketplace policy changes — all without taking autonomous actions. Think of it as an experienced reseller looking over your shoulder.',
  },
  {
    category: 'Technical',
    question: 'Is there a mobile app?',
    answer:
      'For Visibility is a progressive web app (PWA) that works on any modern browser, including mobile Safari and Chrome. You can install it to your home screen for an app-like experience. Native iOS and Android apps are on our roadmap.',
  },
  {
    category: 'Technical',
    question: 'How do I connect my eBay account?',
    answer:
      'Navigate to Settings → Integrations and click "Connect eBay." You\'ll be redirected to eBay\'s official authorization page. Once approved, your listings, orders, and messages sync automatically. The same flow applies to Mercari and Poshmark.',
  },
  {
    category: 'Technical',
    question: 'What happens if a marketplace API goes down?',
    answer:
      'For Visibility gracefully handles API disruptions. Your locally cached data remains accessible, pending operations are queued, and you receive a notification when the connection is restored. We monitor marketplace API health continuously and alert you proactively.',
  },
  {
    category: 'Account & Support',
    question: 'How do I reset my password?',
    answer:
      'On the sign-in page, click "Forgot password" and enter your email. You\'ll receive a password reset link within a few minutes. If you don\'t see it, check your spam folder. For persistent issues, contact support.',
  },
  {
    category: 'Account & Support',
    question: 'Can I have multiple team members on one account?',
    answer:
      'Yes. The Power plan includes 3 seats and the Studio plan includes 10 seats. Team members can have role-based permissions — owner, manager, viewer — so you control who can list, manage settings, or just view analytics.',
  },
  {
    category: 'Account & Support',
    question: 'How do I contact support?',
    answer:
      'Free plan users get community support via our Discord. Pro users have email support with a 24-hour response target. Power users get phone and chat support. Studio users receive a dedicated account manager with an SLA-backed response time. Email us at support@forvisibility.com.',
  },
];
